import React from "react";
import { motion } from "framer-motion";
import css from "./Hero.module.css";
import HeroImg from "../assets/hero.png";
import { IoIosArrowRoundForward } from "react-icons/io";

const Hero = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }}
      exit={{ opacity: 0, y: -30, transition: { duration: 0.4, ease: "easeIn" } }}
      className={css.container}
    >
      <div className={css.h_sides}>
        <span className={css.text1}>Skin Protection Cream</span>
        <div className={css.text2}>
          <span>Trendy Collection</span>
          <span>
            Seedily say has suitable disposal and buy. Exercise joy man children
          </span>
        </div>
      </div>
      <div className={css.wrapper}>
        <motion.div
          className={css.blueCircle}
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1, transition: { duration: 1 } }}
        />
        <motion.img
          src={HeroImg}
          alt="hero"
          width={400}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1, transition: { duration: 1 } }}
        />
        <motion.div className={css.cart2} initial={{ x: 30, opacity: 0 }} animate={{ x: 0, opacity: 1 }}>
          <div className={css.singup}>
            <span>Best Signup Offers</span>
            <div>
              <IoIosArrowRoundForward />
            </div>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Hero;
